import { useQuery } from '@tanstack/react-query';
import { audit } from '@/api/endpoints';
import { Notice } from '@/components/Notice';
import { formatDateTime } from '@/lib/format';

export function AuditPage() {
  const entries = useQuery({ queryKey: ['audit'], queryFn: () => audit.list(100) });
  const chain = useQuery({ queryKey: ['audit-verify'], queryFn: audit.verify });

  return (
    <>
      <div className="page-head">
        <h1>Audit trail</h1>
        <p>
          Every privileged action, including the ones that were refused. Rows are hash-chained, so
          an edit or deletion shows up as a broken chain.
        </p>
      </div>

      {chain.data && !chain.data.intact && (
        <Notice tone="error">
          The audit chain is broken from row {chain.data.first_broken_row_id}. Someone or something
          modified the log outside the application. Treat this as a security incident.
        </Notice>
      )}
      {chain.data?.intact && <Notice tone="info">Chain verified. No rows altered or removed.</Notice>}

      <section className="panel">
        <div className="panel-body flush">
          {(entries.data ?? []).length === 0 ? (
            <div className="empty">No entries.</div>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>Time</th>
                  <th>Who</th>
                  <th>Action</th>
                  <th>Object</th>
                  <th>Result</th>
                </tr>
              </thead>
              <tbody>
                {(entries.data ?? []).map((entry) => (
                  <tr key={entry.id}>
                    <td className="num">{formatDateTime(entry.at)}</td>
                    <td>{entry.actor_email ?? 'system'}</td>
                    <td>{entry.action}</td>
                    <td style={{ color: 'var(--text-secondary)' }}>
                      {entry.object_type ? `${entry.object_type} ${entry.object_ref ?? ''}` : '—'}
                    </td>
                    <td
                      style={{
                        color: entry.result === 'DENIED' ? 'var(--loss)' : 'var(--text-secondary)',
                      }}
                    >
                      {entry.result.toLowerCase()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </section>
    </>
  );
}
